import { render, staticRenderFns } from "./ItemStatus.vue?vue&type=template&id=516665f2&scoped=true"
import script from "./ItemStatus.vue?vue&type=script&lang=js"
export * from "./ItemStatus.vue?vue&type=script&lang=js"
import style0 from "./ItemStatus.vue?vue&type=style&index=0&id=516665f2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516665f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('516665f2')) {
      api.createRecord('516665f2', component.options)
    } else {
      api.reload('516665f2', component.options)
    }
    module.hot.accept("./ItemStatus.vue?vue&type=template&id=516665f2&scoped=true", function () {
      api.rerender('516665f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/po/ItemStatus.vue"
export default component.exports